import { useGetReturnOnAdSpendCalculationQuery } from '@features/reports';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { Campaign } from '../subdomains/visitation/api';

export type CalculationReturn = {
  value: number | null;
  isFetching: boolean;
};

export type UseReturnOnAdSpendOptions = {
  campaign: Pick<Campaign, 'startDate' | 'endDate' | 'id'>;
  reportDate: string | null;
  sales: number | null;
  adSpend: number | null;
};

export const useReturnOnAdSpend = (
  options: UseReturnOnAdSpendOptions
): CalculationReturn => {
  const { reportDate, campaign, sales, adSpend } = options;

  const { data, isFetching } = useGetReturnOnAdSpendCalculationQuery(
    typeof sales === 'number' && reportDate
      ? {
          start_date: campaign.startDate,
          end_date: campaign.endDate,
          report_date: reportDate,
          sales,
          ad_spend: adSpend ?? 0,
        }
      : skipToken
  );

  const value = data?.data.return_on_ad_spend ?? null;

  return useMemo(
    () => ({
      value,
      isFetching,
    }),
    [value, isFetching]
  );
};
